import React from 'react';
import styled from 'styled-components';
import { FiStar } from 'react-icons/fi';
import { Colors } from '../utils/colors';
import { Sizes } from '../utils/sizes';

const Wrap = styled.section`
  width: 100%;
  background: #0d0d0d;
  padding: 80px 24px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(255,215,0,0.2), transparent);
  }
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 50px;
`;

const Label = styled.p`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: ${Colors.yellow};
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin: 0 0 10px;
`;

const Title = styled.h2`
  color: #fff;
  font-size: clamp(1.6rem, 3vw, 2.2rem);
  font-weight: 800;
  margin: 0;
`;

const Grid = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;

  @media (max-width: ${Sizes.mediaQueryBreak1}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: ${Sizes.mediaQueryBreak3}) {
    grid-template-columns: 1fr;
    max-width: 480px;
  }
`;

const Card = styled.div`
  background: #181818;
  border: 1px solid rgba(255,215,0,0.1);
  border-radius: 12px;
  padding: 28px 22px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  transition: border-color 0.2s;

  &:hover {
    border-color: rgba(255,215,0,0.3);
  }
`;

const Stars = styled.div`
  color: ${Colors.yellow};
  font-size: 14px;
  letter-spacing: 2px;
`;

const Quote = styled.p`
  color: rgba(255,255,255,0.75);
  font-size: 0.88rem;
  line-height: 1.65;
  flex: 1;
  margin: 0;
  font-style: italic;
`;

const Author = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(255,255,255,0.06);
`;

const Avatar = styled.div`
  width: 38px;
  height: 38px;
  border-radius: 50%;
  flex-shrink: 0;
  background-size: cover;
  background-position: center;
  border: 2px solid rgba(255,215,0,0.25);
  background-image: url('${p => p.src}');
`;

const AuthorName = styled.span`
  color: #fff;
  font-size: 0.85rem;
  font-weight: 700;
`;

const testimonials = [
  {
    name: 'Andréia',
    avatar: 'user-feedback-1.jpeg',
    text: '"Sou do Paraguay e adoro seus vídeos! Faz tempo que estou tentando tocar meu violão e suas cifras me ajudam muito. Acabei de adquirir seus e-books."',
  },
  {
    name: 'Babi',
    avatar: 'user-feedback-2.png',
    text: '"Que Deus te abençoe! Estou vendo seus vídeos no YouTube para aprender violão e tocar as músicas na igreja. Muito obrigada."',
  },
  {
    name: 'Carlos',
    avatar: 'user-feedback-3.png',
    text: '"Parabéns pela iniciativa! Estou começando violão e gostei muito das cifras e ritmos simplificados."',
  },
  {
    name: 'Camila',
    avatar: 'user-feedback-4.png',
    text: '"Sua didática é muito boa. Já tentei aprender violão antes mas não ia pra frente. Com você está sendo diferente. Os e-books estão super organizados."',
  },
];

const Section = () => (
  <Wrap>
    <Header>
      <Label><FiStar size={13} /> Depoimentos</Label>
      <Title>O que nossos alunos dizem</Title>
    </Header>
    <Grid>
      {testimonials.map((t) => (
        <Card key={t.name}>
          <Stars>★★★★★</Stars>
          <Quote>{t.text}</Quote>
          <Author>
            <Avatar src={t.avatar} />
            <AuthorName>{t.name}</AuthorName>
          </Author>
        </Card>
      ))}
    </Grid>
  </Wrap>
);

export default Section;
